export interface BiTrackParams {
    event_type: string; // 功能名
    source_type?: string; // 来源
    other_param?: string; // 其他参数，普通string
    event_detail_str?: string; // 事件详情。jsonString传递的数据量大推荐使用这个
    module_type: string; // 模块类型
}

export interface BiTrackEventType {
    sourceType: string;
    otherParam?: string;
    eventDetailStr?: Record<string, unknown> | string;
}

/**
 * 埋点枚举值:
 * 318PLG 相关埋点: https://alidocs.dingtalk.com/i/nodes/G1DKw2zgV2R0k2b2CBwPRD6MVB5r9YAn?doc_type=wiki_doc&iframeQuery=utm_source=portal&utm_medium=portal_recent&rnd=0.853344008338717
 */
export enum EurekaTrackEventType {
    SHARE_INFO = 'SS Share Info',
    AGENT_VIEW = 'SS Agent View',
    QUICK_RESEARCH = 'SS Quick Research',
    HOME = 'SS Eureka IP Home Page',
    WORK_PROJECT = 'SS Work Project',
    TRIZ = 'SS TRIZ Mind',
    COMPANY_SCOUT = 'SS COMPANY SCOUT',
    AGENT_SUBMIT = 'SS AGENT SUBMIT',
    AGENT_CLICK = 'SS AGENT CLICK',
    TOOL_CLICK = 'SS TOOL CLICK',
    SS_PLG_PAGE_VIEW = 'SS PLG PAGE VIEW',
    SS_AI_NOVELTY_SEARCH = 'SS AI Novelty Search',
    SS_AI_FTO_REPORT = 'SS AI FTO Report',
    SS_IP_IMAGE_SEARCH_AGENT = 'SS IP Image Search Agent',
    SS_EUREKA_UPGRADE_PAGE = 'SS EUREKA UPGRADE PAGE'
}
